//为方法名定义一个常量，这样做的好处是：不容易写错。
export const MY_VALUE = 'myValue';

export default {
    namespaced:true,//命令空间必须有，否则该类会挂在根下。
    state: {
        goods:{
            name:'',
            total:0
        }
    },
    getters:{
        myIncrease(state){
            return state.goods.total;
        },
        myGoodsName(state){
            return state.goods.name;
        }
    },
    mutations: {
        ADD_VALUE_MUTATION(state, n){
            this.state.cart.goods.total += n;
        },
        SUB_VALUE_MUTATION(state, n){
            this.state.cart.goods.total -= n;
            if(this.state.cart.goods.total<0){
                this.state.cart.goods.total=0;
            }
        },
        SET_GOODS_NAME(state, name){
            this.state.cart.goods.name = name;
        }
    },
    actions: {
        addValueAction({commit},val){
            commit('ADD_VALUE_MUTATION',val.step);
        },
        subValueAction({commit},val){
            commit('SUB_VALUE_MUTATION',val.step);
        },
        setGoodsName({commit},val){
            commit('SET_GOODS_NAME',val.name);
        }
    }
}
